module.exports = __webpack_public_path__ + "static/media/konsultoitava-vertical.e445151a.png";